module.exports = __webpack_public_path__ + "img/xfs-down-close.86f406d1.png";